import { Divider, ListItemButton, Box, Stack } from '@mui/material';
import { useEffect, useState, useCallback, useMemo } from 'react';
import { NavBar } from '../appBars/navBar/navBar';
import { ListStyled } from './partnersStyles';
import { PartnerClient } from '../../helpers/client';
import { apiKey, appStyleMode, imagesUri } from '../../helpers/clientConfigs';
import { Partner } from 'orderme-api-integration-client';
import { Linear } from '../progressBars/linear';
import { ImageLoader } from '../imgLoader/imgLoader';
import { useTranslation } from 'react-i18next';
import { AppStyle } from '../../helpers/appStyle';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { PartnersRoute } from '../../routes/allRoutes';

export function Partners() {
  const partnerClient = useMemo(() => new PartnerClient(), []);
  const [partners, setPartners] = useState<Partner[]>();
  const { t } = useTranslation();
  const isMobileApp = appStyleMode === AppStyle.Mobile;

  const getPartners = useCallback(() => {
    partnerClient
      .get()
      .then((response) => {
        setPartners(response);
      })
      .catch((err) => console.log(err));
  }, [partnerClient]);

  useEffect(() => {
    getPartners();
  }, [getPartners]);

  const openSite = (url: string) => {
    if (window.cordova) {
      window.cordova.InAppBrowser.open(url, '_system');
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <NavBar barTitle={t('info:partners')} />
      <BreadcrumbsBar paths={[{ path: PartnersRoute }]} />
      {!partners && <Linear />}
      {partners && (
        <ListStyled isMobile={isMobileApp}>
          {partners.map((partner, index) => {
            return (
              <>
                <ListItemButton
                  sx={{
                    ':hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                  onClick={() => openSite(partner.webAddress)}
                  key={index}
                >
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      width: '100%',
                      height: {
                        xs: isMobileApp ? (window.innerHeight - 56) / 4 : '150px',
                        sm: isMobileApp ? (window.innerHeight - 56) / 4 : '250px',
                      },
                      minHeight: '150px',
                    }}
                  >
                    <ImageLoader
                      sx={{ maxWidth: '100%', maxHeight: '100%' }}
                      src={`${imagesUri}/${partner.logoId}?orderme-api-key=${apiKey}&height=500`}
                      alt={partner.name}
                    />
                  </Stack>
                </ListItemButton>
                <Divider />
              </>
            );
          })}
        </ListStyled>
      )}
    </Box>
  );
}
